<template>
  <v-container fluid>
    <v-row>
      <v-col cols="6" class="text-h6 font-weight-bold"> সন্তানের তালিকা </v-col>

      <v-col cols="6" class="text-end">
        <v-btn
          color="secondary"
          size="small"
          class="me-3 rounded-lg"
          @click="openModal"
        >
          <v-icon start>mdi-plus-circle-outline</v-icon>
          যোগ করুন
        </v-btn>
      </v-col>

      <!-- Table -->
      <v-col cols="12">
        <v-table class="language-table">
          <thead>
            <tr>
              <th>নাম</th>
              <th>জন্ম তারিখ</th>
              <th>লিঙ্গ</th>
              <th>জন্ম নিবন্ধন</th>
              <th>শিক্ষা</th>
              <th width="120">অ্যাকশন</th>
            </tr>
          </thead>

          <tbody>
            <tr v-if="ChildrenData.length === 0">
              <td colspan="6" class="text-center py-6">কোন তথ্য পাওয়া যায়নি</td>
            </tr>

            <tr v-for="(item, index) in ChildrenData" :key="index">
              <td>{{ item.name_bn }}</td>
              <td>{{ item.dob }}</td>
              <td>{{ item.gender }}</td>
              <td>{{ item.birth_reg }}</td>
              <td>{{ item.education }}</td>

              <td>
                <div class="d-flex align-center">
                  <v-btn icon size="small" color="primary" variant="text">
                    <v-icon>mdi-pencil-outline</v-icon>
                  </v-btn>

                  <v-btn icon size="small" color="red" variant="text">
                    <v-icon>mdi-delete-outline</v-icon>
                  </v-btn>
                </div>
              </td>
            </tr>
          </tbody>
        </v-table>
      </v-col>
    </v-row>

    <!-- Modal -->
    <form>
      <InsertModal ref="Modal" title="সন্তানের তথ্য" :width="900">
        <template #modalBody>
          <v-row>
            <!-- NID / Birth Registration -->
            <v-col cols="12">
              <div class="mb-2 font-weight-medium">
                এনআইডি/জন্মনিবন্ধন <span class="text-red">*</span>
              </div>

              <v-radio-group v-model="form.identity_type" inline hide-details>
                <v-radio label="এনআইডি" value="nid"></v-radio>
                <v-radio label="জন্মনিবন্ধন" value="birth"></v-radio>
              </v-radio-group>
            </v-col>

            <!-- Identity Number -->
            <v-col cols="12" md="6">
              <v-text-field
                v-model="form.identity_number"
                label="এনআইডি নম্বর"
                placeholder="এনআইডি নম্বর লিখুন"
                variant="outlined"
                density="comfortable"
              />
            </v-col>

            <!-- Identity Copy -->
            <v-col cols="12" md="6">
              <v-file-input
                v-model="form.identity_copy"
                variant="outlined"
                density="comfortable"
                label="এনআইডি-এর কপি"
                accept=".pdf,.jpg,.jpeg,.png"
                prepend-inner-icon="mdi-file"
                prepend-icon=""
                hint="সর্বোচ্চ সাইজ ৫ এমবি (ফরম্যাট: pdf, png, jpg, jpeg)"
                persistent-hint
              />
            </v-col>

            <!-- Date of Birth -->
            <v-col cols="12" md="6">
              <v-menu
                v-model="childrenDobMenu"
                :close-on-content-click="false"
                location="bottom"
              >
                <template #activator="{ props }">
                  <v-text-field
                    :model-value="formatDate(form.children_dob)"
                    label="জন্মতারিখ"
                    prepend-inner-icon="mdi-calendar"
                    variant="outlined"
                    density="comfortable"
                    readonly
                    class="mb-3"
                    v-bind="props"
                  />
                </template>

                <v-date-picker
                  style="margin-top: -20px"
                  v-model="form.children_dob"
                  color="primary"
                  hide-header
                  @update:modelValue="childrenDobMenu = false"
                />
              </v-menu>
            </v-col>

            <v-col cols="12" md="6"></v-col>

            <!-- Bangla Name -->
            <v-col cols="12" md="6">
              <v-text-field
                v-model="form.name_bn"
                label="নাম (বাংলা)"
                placeholder="সন্তানের বাংলা নাম"
                variant="outlined"
                density="comfortable"
              />
            </v-col>

            <!-- English Name -->
            <v-col cols="12" md="6">
              <v-text-field
                v-model="form.name_en"
                label="নাম (ইংরেজি)"
                placeholder="সন্তানের ইংরেজি নাম"
                variant="outlined"
                density="comfortable"
              />
            </v-col>

            <!-- District -->
            <v-col cols="12" md="6">
              <v-select
                v-model="form.district"
                :items="districts"
                label="জেলা"
                placeholder="জেলা বাছাই করুন"
                variant="outlined"
                density="comfortable"
              />
            </v-col>

            <!-- Mobile -->
            <v-col cols="12" md="6">
              <v-text-field
                v-model="form.mobile"
                label="মোবাইল নম্বর"
                placeholder="01XXXXXXXXX"
                variant="outlined"
                density="comfortable"
              >
                <template #prepend-inner>
                  <span class="mr-2">+88</span>
                </template>
              </v-text-field>
            </v-col>

            <!-- Passport Number -->
            <v-col cols="12" md="6">
              <v-text-field
                v-model="form.passport_number"
                label="পাসপোর্ট নম্বর"
                placeholder="পাসপোর্ট নম্বর"
                variant="outlined"
                density="comfortable"
              />
            </v-col>

            <!-- Passport Copy -->
            <v-col cols="12" md="6">
              <v-file-input
                v-model="form.passport_copy"
                variant="outlined"
                density="comfortable"
                label="পাসপোর্টের কপি আপলোড"
                accept=".pdf,.jpg,.jpeg,.png"
                prepend-inner-icon="mdi-file"
                prepend-icon=""
                hint="সর্বোচ্চ সাইজ ৫ এমবি (ফরম্যাট: pdf, jpg, jpeg, png)"
                persistent-hint
              />
            </v-col>

            <!-- Govt Job -->
            <v-col cols="12" md="12">
              <div class="mb-2 font-weight-medium">চাকুরিজীবী কি না?</div>

              <v-radio-group v-model="form.is_job_holder" inline hide-details>
                <v-radio label="হ্যাঁ" :value="true"></v-radio>
                <v-radio label="না" :value="false"></v-radio>
              </v-radio-group>
            </v-col>

            <!-- Disabled -->
            <v-col cols="12" md="12">
              <div class="mb-2 font-weight-medium">প্রতিবন্ধী কি না?</div>

              <v-radio-group v-model="form.is_disabled" inline hide-details>
                <v-radio label="হ্যাঁ" :value="true"></v-radio>
                <v-radio label="না" :value="false"></v-radio>
              </v-radio-group>
            </v-col>

            <!-- Married -->
            <v-col cols="12" md="12">
              <div class="mb-2 font-weight-medium">বিবাহিত কি না?</div>

              <v-radio-group v-model="form.is_married" inline hide-details>
                <v-radio label="হ্যাঁ" :value="true"></v-radio>
                <v-radio label="না" :value="false"></v-radio>
              </v-radio-group>
            </v-col>

            <!-- Alive Status -->
            <v-col cols="12" md="12">
              <div class="d-flex align-center">
                সন্তানের অবস্থা:
                <v-checkbox v-model="form.is_dead" label="মৃত" hide-details />
              </div>
            </v-col>
          </v-row>
        </template>

        <template #modalFooter>
          <v-row>
            <v-col cols="12">
              <v-btn
                color="primary"
                size="large"
                class="me-3 rounded-lg"
                type="submit"
              >
                <v-icon start> mdi-content-save-outline </v-icon>
                সংরক্ষণ করুন
              </v-btn>

              <v-btn
                color="grey-darken-1"
                variant="outlined"
                size="large"
                class="rounded-lg"
                @click="resetForm"
              >
                <v-icon start>mdi-refresh</v-icon>
                রিসেট
              </v-btn>
            </v-col>
          </v-row>
        </template>
      </InsertModal>
    </form>
  </v-container>
</template>

<script>
import InsertModal from "@/components/shared/InsertModal.vue";

export default {
  name: "ChildrenComponent",

  components: {
    InsertModal,
  },

  data() {
    return {
      ChildrenData: [],

      genders: ["পুরুষ", "মহিলা"],

      educationList: [
        "প্রাক-প্রাথমিক",
        "প্রাথমিক",
        "মাধ্যমিক",
        "উচ্চ মাধ্যমিক",
        "স্নাতক",
      ],
      childrenDobMenu: false,
      childTypes: ["পুত্র", "কন্যা", "দত্তক"],

      form: {
        name_bn: "",
        name_en: "",
        dob: "",
        gender: "",
        birth_reg: "",
        birth_reg_copy: null,
        education: "",
        institution: "",
        disabled: false,
        child_type: "",
        attachment: null,
      },
    };
  },

  methods: {
    openModal() {
      this.$refs.Modal.openModal();
    },

    formatDate(date) {
      if (!date) return "";

      const d = new Date(date);

      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear();

      return `${day}-${month}-${year}`;
    },

    resetForm() {
      this.form = {
        name_bn: "",
        name_en: "",
        dob: "",
        gender: "",
        birth_reg: "",
        birth_reg_copy: null,
        education: "",
        institution: "",
        disabled: false,
        child_type: "",
        attachment: null,
      };
    },
  },
};
</script>
